/**
 * 需求来源：docs/合作页、CJ Entity、Ads开户落地页3个/AI提示词.md（第2次提交 任务1）、advertisingservice.html。
 * Section 9：cj-ads-light-cta 底部亮色 CTA（背景图 + 玻璃卡片，三端断点 1100/991/767/480）。
 * 主 CTA「Apply for an Ad Account」打开工单弹窗。
 * 260715 第25次提交(第23次补充 需求60)：Apply 按钮下方新增次级按钮「Explore CJ Ads」，
 *   点击新窗口跳转 CJ Ads 平台 LINKS.cjAds(https://ads.cjdropshipping.com)，不打开工单弹窗。
 * 注意事项：全部文案经 ConstantsContext 取词（LIGHT_CTA）；跳转链接取 constants 的 LINKS。
 */
import React, { useContext } from 'react';
import TicketContext from './TicketContext';
import ConstantsContext from './ConstantsContext';
import { LINKS } from '../constants';

function Check() {
  return (
    <span className="cj-ads-light-cta__check">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M5 12.5L9.2 16.5L19 7" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  );
}

function LightCta() {
  const openTicket = useContext(TicketContext);
  const { LIGHT_CTA } = useContext(ConstantsContext);
  return (
    <section className="cj-ads-light-cta">
      <div className="cj-ads-light-cta__overlay" />
      <div className="cj-ads-light-cta__inner">
        <div className="cj-ads-light-cta__content">
          <span className="cj-ads-light-cta__eyebrow">{LIGHT_CTA.eyebrow}</span>
          <h2 className="cj-ads-light-cta__title">{LIGHT_CTA.title}</h2>
          <p className="cj-ads-light-cta__description">{LIGHT_CTA.description}</p>
          <div className="cj-ads-light-cta__features">
            {LIGHT_CTA.features.map((f) => (
              <div className="cj-ads-light-cta__feature" key={f}>
                <Check />
                <span>{f}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="cj-ads-light-cta__action">
          <div className="cj-ads-light-cta__card">
            <span className="cj-ads-light-cta__card-label">{LIGHT_CTA.cardLabel}</span>
            <h3 className="cj-ads-light-cta__card-title">{LIGHT_CTA.cardTitle}</h3>
            <p className="cj-ads-light-cta__card-text">{LIGHT_CTA.cardText}</p>
            <a
              href="#contact-form"
              className="cj-ads-light-cta__button"
              aria-label="Apply for a CJ advertising account"
              onClick={(e) => { e.preventDefault(); openTicket(); }}
            >
              <span>{LIGHT_CTA.button}</span>
              <span className="cj-ads-light-cta__arrow">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M5 12H19M13 6L19 12L13 18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </a>
            <a
              href={LINKS.cjAds}
              className="cj-ads-light-cta__button cj-ads-light-cta__button--secondary"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Explore CJ Ads"
            >
              <span>{LIGHT_CTA.buttonSecondary}</span>
              <span className="cj-ads-light-cta__arrow">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M5 12H19M13 6L19 12L13 18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </a>
            <span className="cj-ads-light-cta__note">{LIGHT_CTA.note}</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LightCta;
